import React, { useEffect, useState } from "react";
import Input from "../../../components/FormComponents/Input";

const timeOptions = [{ id: "minutes", name: "Minutes" }];

const HttpReqRateLimiter = ({ rateLimiter, onChange }) => {
  // State for duration
  const [durationValue, setDurationValue] = useState(0);
  const [durationUnit, setDurationUnit] = useState("minutes");

  // State for cool_off_interval
  const [coolOffValue, setCoolOffValue] = useState(0);
  const [coolOffUnit, setCoolOffUnit] = useState("minutes");

  // Initialize duration state from prop
  useEffect(() => {
    if (rateLimiter.duration) {
      const [val, unit] = rateLimiter.duration.split(" ");
      setDurationValue(Number(val));
      setDurationUnit(unit);
    }
    if (rateLimiter.cool_off_interval) {
      const [val, unit] = rateLimiter.cool_off_interval.split(" ");
      setCoolOffValue(Number(val));
      setCoolOffUnit(unit);
    }
  }, [rateLimiter.duration, rateLimiter.cool_off_interval]);

  const handleChange = (key, value) => {
    const updated = { ...rateLimiter, [key]: value };
    onChange(updated);
  };

  const handleMaxLimitChange = (e) => {
    const value = Number(e.target.value);
    handleChange("max_limit", value);
  };

  const handleDurationValueChange = (e) => {
    const value = Number(e.target.value);
    setDurationValue(value);
    handleChange("duration", `${value} ${durationUnit}`);
  };

  const handleDurationUnitChange = (e) => {
    const unit = e.target.value;
    setDurationUnit(unit);
    handleChange("duration", `${durationValue} ${unit}`);
  };

  const handleCoolOffValueChange = (e) => {
    const value = Number(e.target.value);
    setCoolOffValue(value);
    handleChange("cool_off_interval", `${value} ${coolOffUnit}`);
  };

  const handleCoolOffUnitChange = (e) => {
    const unit = e.target.value;
    setCoolOffUnit(unit);
    handleChange("cool_off_interval", `${coolOffValue} ${unit}`);
  };

  return (
    <div className="d_flex gap_3">
      <div>
        <label>Maximum Limit</label>
        <Input type="number" value={rateLimiter.max_limit ?? ""} onChange={handleMaxLimitChange} min={0} />
      </div>

      <div>
        <label>Duration</label>
        <div className="d_flex gap_1">
          <Input
            type="number"
            value={durationValue ?? ""}
            onChange={handleDurationValueChange}
            min={0}
            style={{ width: "80px" }}
          />
          <select className="builder_input" value={durationUnit} onChange={handleDurationUnitChange}>
            {timeOptions.map((opt) => (
              <option key={opt.id} value={opt.id}>
                {opt.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div>
        <label>Cool Off Interval</label>
        <div className="d_flex gap_1">
          <Input
            type="number"
            value={coolOffValue ?? ""}
            onChange={handleCoolOffValueChange}
            min={0}
            style={{ width: "80px" }}
          />
          <select className="builder_input" value={coolOffUnit} onChange={handleCoolOffUnitChange}>
            {timeOptions.map((opt) => (
              <option key={opt.id} value={opt.id}>
                {opt.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};
export default HttpReqRateLimiter;
